import { arrayOf, bool, func } from 'prop-types';
import React, { PureComponent } from 'react';

import { sportEvent } from 'calendar/proptypes';
import ComponentLoadingSection from 'shared/components/ComponentLoadingSection';

import SportHighlightItem from './SportHighlightItem';

export default class SportsCalendar extends PureComponent {
  static propTypes = {
    calendar: arrayOf(sportEvent).isRequired,
    loading: bool.isRequired,
    onItemClick: func.isRequired,
  };

  render() {
    const { calendar, loading, onItemClick } = this.props;

    return (
      <ComponentLoadingSection loading={loading}>
        <ul>
          {calendar.map(event => (
            <SportHighlightItem
              key={event.id}
              event={event}
              onClick={onItemClick}
            />
          ))}
        </ul>
      </ComponentLoadingSection>
    );
  }
}
